module.exports = __webpack_public_path__ + "img/denmark-ill-defined-causes-male.f2e00c2b.png";